import type { Mention } from '../../hooks';

export function mergeMentionsByRange(
  base: Mention[],
  additions: Mention[]
): Mention[] {
  const all = [...base];
  const ranges = base.map(m => ({ start: m.start, end: m.end }));

  additions.forEach(m => {
    const overlaps = ranges.some(r => !(m.end <= r.start || m.start >= r.end));
    if (!overlaps) {
      all.push(m);
      ranges.push({ start: m.start, end: m.end });
    }
  });

  return all.sort((a, b) => a.start - b.start);
}

export function dedupeMentionsByRange(mentions: Mention[]): Mention[] {
  const sorted = [...mentions].sort((a, b) => a.start - b.start);
  const result: Mention[] = [];
  for (const m of sorted) {
    const hasOverlap = result.some(
      r => !(m.end <= r.start || m.start >= r.end)
    );
    if (!hasOverlap) result.push(m);
  }
  return result;
}
